import RangeSlider from 'vue-range-slider';
import 'vue-range-slider/dist/vue-range-slider.css';

import {
	mapActions,
	mapState
} from 'vuex';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

export default {
	actions,
	getters,
	state,
	mutations,
	name: 'simulator',
	data() {
		return {
			form: {
				schoolName: '',
				contactName: '',
				contactEmailAddress: '',
				mobilePhoneNumber: '',
				studentsQuantity: 500,
				plan: '',
				levels: [],
				voucherNumber: ''
			}
		};
	},
	components: {
		RangeSlider
	},
	computed: {
		...mapState({
			levelsType: (state) => state.ENUM.Levels
		})
	},
	methods: {
		...mapActions([
			'sendFormLead',
		]),
		sendForm() {
			this.sendFormLead(this.form).then(() => {

				this.$router.push({
					name: 'SimulatorValues'
				});

			}).catch((error) => {
				alert(error.response.data.statusDescription);
			});
		}
	}
};



// WEBPACK FOOTER //
// ./sources/app/simulator/simulator/index.js